import Api from '../api'

export default ({

  state: {
    itemGroupLists: [],
    itemSubGroupLists: [],
    measurementUnitLists: [],
    unitConversionLists: [],
    itemPropertyLists: []
  },
  mutations: {
    ADD_ITEM_GROUP (state, itemGroup) {
      let itemGroupList = state.itemGroupLists.concat(itemGroup)
      state.itemGroupLists = itemGroupList
    },
    ADD_ITEM_PROPERTY (state, itemProperty) {
      let itemPropertyList = state.itemPropertyLists.concat(itemProperty)
      state.itemPropertyLists = itemPropertyList
    },
    ADD_ITEM_SUB_GROUP (state, itemSubGroupLists) {
      let itemSubGroupList = state.itemSubGroupLists.concat(itemSubGroupLists)
      state.itemSubGroupLists = itemSubGroupList
    },
    ADD_MEASUREMENT_UNIT (state, measurementUnitLists) {
      let measurementUnitList = state.measurementUnitLists.concat(measurementUnitLists)
      state.measurementUnitLists = measurementUnitList
    },
    ADD_UNIT_CONVERSION(state, unitConversionLists) {
      let unitConversionList = state.measurementUnitLists.concat(unitConversionLists)
      state.unitConversionLists = unitConversionList
    },
    SET_ITEM_GROUP (state, itemGroupList) {
      state.itemGroupLists = itemGroupList
    },
    SET_ITEM_PROPERTY (state, itemPropertyList) {
      state.itemPropertyLists = itemPropertyList
    },
    SET_ITEM_SUB_GROUP (state, itemSubGroupList) {
      state.itemSubGroupLists = itemSubGroupList
    },
    SET_MEASUREMENT_UNIT (state, measurementUnitList) {
      state.measurementUnitLists = measurementUnitList
    },
    SET_UNIT_CONVERSION(state, unitConversionList) {
      state.unitConversionLists = unitConversionList
    },
    DELETE_ITEM_GROUP (state, groupId) {
      let itemGroup = state.itemGroupLists.filter(a => a.id !== groupId.id)
      state.itemGroupLists = itemGroup
    },
    DELETE_ITEM_PROPERTY (state, propertyId) {
      let property = state.itemPropertyLists.filter(a => a.id !== propertyId.id)
      state.itemPropertyLists = property
    },
    DELETE_ITEM_SUB_GROUP (state, subGroupId) {
      let itemSubGroup = state.itemSubGroupLists.filter(a => a.id !== subGroupId.id)
      state.itemSubGroupLists = itemSubGroup
    },
    DELETE_MEASUREMENT_UNIT (state, measurementUnitId) {
      let measurementUnit = state.measurementUnitLists.filter(a => a.id !== measurementUnitId.id)
      state.measurementUnitLists = measurementUnit
    },
    DELETE_UNIT_CONVERSION(state, unitConversionId) {
      let unitConversion = state.unitConversionLists.filter(a => a.id !== unitConversionId.id)
      state.unitConversionLists = unitConversion
    },
    UPDATE_ITEM_GROUP (state, updateItemGroupId) {
      state.itemGroupLists = state.itemGroupLists.map(itemGroup => itemGroup.id !== updateItemGroupId.id ? itemGroup : {...itemGroup, ...updateItemGroupId})
    },
    UPDATE_ITEM_PROPERTY (state, updateItemPropertyId) {
      state.itemPropertyLists = state.itemPropertyLists.map(itemProperty => itemProperty.id !== updateItemPropertyId.id ? itemProperty : {...itemProperty, ...updateItemPropertyId})
    },
    UPDATE_ITEM_SUB_GROUP (state, updateItemSubGroupId) {
      state.itemSubGroupLists = state.itemSubGroupLists.map(itemSubGroup => itemSubGroup.id !== updateItemSubGroupId.id ? itemSubGroup : {...itemSubGroup, ...updateItemSubGroupId})
    },
    UPDATE_MEASUREMENT_UNIT (state, updateMeasurementId) {
      state.measurementUnitLists = state.measurementUnitLists.map(measurementUnit => measurementUnit.id !== updateMeasurementId.id ? measurementUnit : {...measurementUnit, ...updateMeasurementId})
    },
    UPDATE_UNIT_CONVERSION(state, conversionId) {
      state.unitConversionLists = state.unitConversionLists.map(unitConv => unitConv.id !== conversionId.id ? unitConv : {...unitConv, ...conversionId})
    },
    ITEM_SUBGROUP_DROPLIST(state, itemSubGroup) {
      state.itemSubGroupLists = itemSubGroup
    },
    ITEM_GROUP_DROPLIST(state, itemGroup) {
      state.itemGroupLists = itemGroup
    },
    MEASUREMENT_DROPLIST(state, measurementUnit) {
      state.measurementUnitLists = measurementUnit
    }
  },
  actions: {
    async createItemGroup({commit}, itemgroup) {
      let response = await Api.request('post', '/itemGroup/' + this.state.organisationid + '/' + this.state.user.id, itemgroup)
      let savedItemGroup = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ITEM_GROUP', savedItemGroup)
      }
      return response
    },
    async createItemProperty({commit}, itemProperty) {
      let response = await Api.request('post', '/itemGroup/createItemProperty/' + this.state.organisationid + '/' + this.state.user.id, itemProperty)
      let savedItemProperty = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ITEM_PROPERTY', savedItemProperty)
      }
      return response
    },
    async createItemSubGroup({commit}, itemsubgroup) {
      let response = await Api.request('post', '/itemGroup/itemSubGroup/' + this.state.organisationid + '/' + this.state.user.id, itemsubgroup)
      let savedItemSubGroup = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ITEM_SUB_GROUP', savedItemSubGroup)
      }
      return response
    },
    async createMesurementUnit({commit}, measurementUnit) {
      let response = await Api.request('post', '/measurementUnit/' + this.state.organisationid + '/' + this.state.user.id, measurementUnit)
      let savedMeasurementUnit = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_MEASUREMENT_UNIT', savedMeasurementUnit)
      }
      return response
    },
    async createUnitConversion({commit}, unitConversion) {
      let response = await Api.request('post', '/measurementUnit/createUnitConversion/' + this.state.organisationid, unitConversion)
      let savedUnitConversion = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_UNIT_CONVERSION', savedUnitConversion)
      }
      return response
    },
    async loadItemGroupList({commit}) {
      let response = await Api.request('get', '/itemGroup/' + this.state.organisationid, null)
      commit('SET_ITEM_GROUP', response.data.data)
    },
    async loadItemPropertyList({commit}) {
      let response = await Api.request('get', '/itemGroup/itemPropertyList/' + this.state.organisationid, null)
      commit('SET_ITEM_PROPERTY', response.data.data)
    },
    async loadItemSubGroupList({commit}) {
      let response = await Api.request('get', '/itemGroup/itemSubGroup/' + this.state.organisationid, null)
      commit('SET_ITEM_SUB_GROUP', response.data.data)
    },
    async loadMeasurementList({commit}) {
      let response = await Api.request('get', '/measurementUnit/' + this.state.organisationid, null)
      commit('SET_MEASUREMENT_UNIT', response.data.data)
    },
    async loadUnitConversionList({commit}) {
      let response = await Api.request('get', '/measurementUnit/unitConversionList/' + this.state.organisationid, null)
      commit('SET_UNIT_CONVERSION', response.data.data)
    },
    async deleteUnitConversion({commit}, deleteRea) {
      let response = await Api.request('delete', '/measurementUnit/unitConversion/' + deleteRea.conversionId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let unitConversion = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_UNIT_CONVERSION', unitConversion)
      }
      return response
    },
    async deleteItemGroup({commit}, deleteRea) {
      let response = await Api.request('delete', '/itemGroup/' + deleteRea.itemGroupId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let itemGroupLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ITEM_GROUP', itemGroupLists)
      }
      return response
    },
    async deleteItemProperty({commit}, deleteRea) {
      let response = await Api.request('delete', '/itemGroup/updateItemProperty/' + deleteRea.itemPropertyId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let itemPropertyLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_ITEM_PROPERTY', itemPropertyLists)
      }
      return response
    },
    async deleteItemSubGroup({commit}, subGroup) {
      let response = await Api.request('delete', '/itemGroup/itemSubGroup/' + subGroup.itemSubGroupId + '/' + this.state.user.id + '/' + subGroup.deleteReason)
      let itemSubGroupLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ITEM_SUB_GROUP', itemSubGroupLists)
      }
      return response
    },
    async deleteMeasurement({commit}, measurementUnit) {
      let response = await Api.request('delete', '/measurementUnit/' + measurementUnit.measurementUnitId + '/' + this.state.user.id + '/' + measurementUnit.deleteReason)
      let measurementUnitLists = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_MEASUREMENT_UNIT', measurementUnitLists)
      }
      return response
    },
    async updateItemGroup({commit}, groupId) {
      let resp = await Api.request('put', '/itemGroup/' + groupId.id, groupId)
      commit('UPDATE_ITEM_GROUP', resp.data.data)
      return resp
    },
    async updateItemSubGroup({commit}, subGroupId) {
      let resp = await Api.request('put', '/itemGroup/updateItemSubGroup/' + subGroupId.id, subGroupId)
      commit('UPDATE_ITEM_SUB_GROUP', resp.data.data)
      return resp
    },
    async updateMesurementUnit({commit}, measurementId) {
      let resp = await Api.request('put', '/measurementUnit/' + measurementId.id, measurementId)
      commit('UPDATE_MEASUREMENT_UNIT', resp.data.data)
      return resp
    },
    async updateUnitConversion({commit}, unitConversion) {
      let resp = await Api.request('put', '/measurementUnit/unitConversion/' + unitConversion.id, unitConversion)
      commit('UPDATE_UNIT_CONVERSION', resp.data.data)
      return resp
    },
    async itemSubGroupDropDown({commit}) {
      let resp = await Api.request('get', '/itemGroup/itemSubGroupDropDownList/' + this.state.organisationid, null)
      commit('ITEM_SUBGROUP_DROPLIST', resp.data.data)
      return resp
    },
    async itemGroupDropDown({commit}) {
      let resp = await Api.request('get', '/itemGroup/itemGroupDropDownList/' + this.state.organisationid, null)
      commit('ITEM_GROUP_DROPLIST', resp.data.data)
      return resp
    },
    async measurementUnitDropDown({commit}) {
      let resp = await Api.request('get', '/measurementUnit/' + this.state.organisationid, null)
      commit('MEASUREMENT_DROPLIST', resp.data.data)
      return resp
    }
  },
  getters: {

  }
})



// WEBPACK FOOTER //
// ./src/store/itemgroup.js